export default "__VITE_ASSET__DpF_5xWk__"